import { render, staticRenderFns } from "./AppraiserFormExtraDataStep.vue?vue&type=template&id=062249cc&"
import script from "./AppraiserFormExtraDataStep.vue?vue&type=script&lang=ts&"
export * from "./AppraiserFormExtraDataStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports